<template>
    <b-card>
        <div slot="header">
            <strong v-text="selectedEmpresa.nombre"></strong>: 
            <span>Matriz de compatibilidad - {{ descripcionPaso[tipoMatriz.tipo][paso] }}</span>
        </div>
        <b-row>
            <b-col sm="12" v-if="tipoMatriz.tipo == 'almacenamiento'">
                <ingresarProductos v-if="paso == 0" @volverMatriz="volverMatriz"></ingresarProductos>
                <naciones-unidas v-if="paso == 1" @volverMatriz="volverMatriz"></naciones-unidas>
                <sga v-if="paso == 2" @volverMatriz="volverMatriz"></sga>  
                <preguntas v-if="paso === 3" @volverMatriz="volverMatriz"></preguntas>
                <resultadoCompatibilidad v-if="paso == 4" @volverMatriz="volverMatriz"></resultadoCompatibilidad>
            </b-col>     
            <b-col sm="12" v-else>
                <ingresarProductos v-if="paso == 0" @volverMatriz="volverMatriz"></ingresarProductos>
                <un-sga v-if="paso == 1" @volverMatriz="volverMatriz"></un-sga>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { getAcls } from "../../plugins/acl";
import ingresarProductos from './ingresar-productos';
import resultadoCompatibilidad from './resultado-compatibilidad';
import nacionesUnidas from './naciones-unidas';
import sga from './sga';
import preguntas from './preguntas';
import unSga from  './transporte/un-sga';

export default {    
    name: "matrizPasoAPaso",
    components: {
        ingresarProductos,
        resultadoCompatibilidad,
        nacionesUnidas,
        sga,
        preguntas,
        unSga
    },
    data() {
        return {
            producto1: '',
            producto2: '',
            producto1Nombre: '',
            producto2Nombre: '',
            descripcionPaso: {
                'almacenamiento': [
                    'Información General',
                    'Naciones Unidas',
                    'SGA',
                    'Preguntas',
                    'Resultado'
                ],
                'transporte': [
                    'Información General',
                    'Naciones Unidas y SGA'
                ]
            }
        }
    },
    beforeDestroy() {
        this.setPaso(0);
        this.resetProductos();
        this.resetFiltroProductosPagos();
    }, 
    methods: {
        volverMatriz() {
            
            this.setPaso(0);
            this.resetProductos()
            this.$router.push(`/matriz-compatibilidad/${this.tipoMatriz.tipo}`);
        },
        ...mapMutations('matrizCompatibilidad', [
            'setModalMatriz',
            'setPaso',
            'resetProductos',
            'resetFiltroProductosPagos'
        ])
    },
    computed:{
        ...mapGetters('matrizCompatibilidad', [
            'getModalMatriz'
        ]),
        ...mapState('matrizCompatibilidad', [
            'selectedEmpresa',
            'paso',
            'modalMatriz',
            'tipoMatriz'
        ])        
    }
}
</script>